var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeparatorMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 14,
    viewBox: "0 0 375 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-159.961 -27.5884L-132.905 -32.8988L5.62525 48.672C12.1861 52.5353 11.4481 56.8558 3.97687 58.3223C-3.4944 59.7887 -14.8697 57.8457 -21.4306 53.9824L-159.961 -27.5884Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-88.7832 -27.5884L-61.7273 -32.8988L76.803 48.672C83.3639 52.5353 82.6259 56.8558 75.1546 58.3223C67.6833 59.7887 56.308 57.8457 49.7471 53.9824L-88.7832 -27.5884Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-17.6035 -27.5884L9.45236 -32.8988L147.983 48.672C154.544 52.5353 153.806 56.8558 146.334 58.3223C138.863 59.7887 127.488 57.8457 120.927 53.9824L-17.6035 -27.5884Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5742 -27.5884L80.6301 -32.8988L219.16 48.672C225.721 52.5353 224.983 56.8558 217.512 58.3223C210.041 59.7887 198.665 57.8457 192.105 53.9824L53.5742 -27.5884Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.754 -27.5884L151.81 -32.8988L290.34 48.672C296.901 52.5353 296.163 56.8558 288.692 58.3223C281.22 59.7887 269.845 57.8457 263.284 53.9824L124.754 -27.5884Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.289 -27.5884L222.345 -32.8988L360.875 48.672C367.436 52.5353 366.698 56.8558 359.227 58.3223C351.756 59.7887 340.38 57.8457 333.819 53.9824L195.289 -27.5884Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M266.467 -27.5884L293.523 -32.8988L432.053 48.672C438.614 52.5353 437.876 56.8558 430.405 58.3223C422.933 59.7887 411.558 57.8457 404.997 53.9824L266.467 -27.5884Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.002 -27.5884L364.058 -32.8988L502.588 48.672C509.149 52.5353 508.411 56.8558 500.94 58.3223C493.468 59.7887 482.093 57.8457 475.532 53.9824L337.002 -27.5884Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-125.18 -27.5884L-98.1238 -32.8988L40.4065 48.672C46.9674 52.5353 46.2294 56.8558 38.7581 58.3223C31.2868 59.7887 19.9115 57.8457 13.3506 53.9824L-125.18 -27.5884Z",
    fill: "#0F242F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M-54 -27.5884L-26.9441 -32.8988L111.586 48.672C118.147 52.5353 117.409 56.8558 109.938 58.3223C102.467 59.7887 91.0912 57.8457 84.5303 53.9824L-54 -27.5884Z",
    fill: "#0F242F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1797 -27.5884L44.2356 -32.8988L182.766 48.672C189.327 52.5353 188.589 56.8558 181.117 58.3223C173.646 59.7887 162.271 57.8457 155.71 53.9824L17.1797 -27.5884Z",
    fill: "#0F242F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3594 -27.5884L115.415 -32.8988L253.946 48.672C260.506 52.5353 259.768 56.8558 252.297 58.3223C244.826 59.7887 233.451 57.8457 226.89 53.9824L88.3594 -27.5884Z",
    fill: "#0F242F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.537 -27.5884L186.593 -32.8988L325.123 48.672C331.684 52.5353 330.946 56.8558 323.475 58.3223C316.004 59.7887 304.628 57.8457 298.067 53.9824L159.537 -27.5884Z",
    fill: "#0F242F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.25 -27.5884L328.306 -32.8988L466.836 48.672C473.397 52.5353 472.659 56.8558 465.188 58.3223C457.717 59.7887 446.341 57.8457 439.78 53.9824L301.25 -27.5884Z",
    fill: "#0F242F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M230.072 -27.5884L257.128 -32.8988L395.658 48.672C402.219 52.5353 401.481 56.8558 394.01 58.3223C386.539 59.7887 375.163 57.8457 368.603 53.9824L230.072 -27.5884Z",
    fill: "#0F242F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M371.785 -27.5884L398.841 -32.8988L537.371 48.672C543.932 52.5353 543.194 56.8558 535.723 58.3223C528.252 59.7887 516.876 57.8457 510.315 53.9824L371.785 -27.5884Z",
    fill: "#0F242F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparatorMob);
export default __webpack_public_path__ + "static/media/separator_mob.e4a713a7fa17b5c2040fee8d30eb098e.svg";
export { ForwardRef as ReactComponent };